module.exports = __webpack_public_path__ + "static/img/6756_phase_function_Paper_PointsHejduk_Prediction.cd0bbaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6756_phase_function_Paper_PointsHejduk_Prediction.png
// module id = MQHx
// module chunks = 0